module.exports = __webpack_public_path__ + "static/media/argentina@2x.4e66f750.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/compra-segura/argentina@2x.png
// module id = 246
// module chunks = 0